/*
 * Copyright (c) TIKI Inc.
 * MIT license. See LICENSE file in root directory.
 */
/**
 * @file Entry point module for the Plugin.
 *
 * @module tiki-capture-receipt-capacitor
 * @license MIT
 */
import { registerPlugin } from '@capacitor/core';
import { ReceiptCapture } from './receipt-capture';
/**
 * Registers the {@link ReceiptCapturePlugin} with Capacitor.
 */
const plugin = registerPlugin('ReceiptCapture', {
    web: () => import('./receipt-capture-web').then((m) => new m.ReceiptCaptureWeb()),
});
/**
 * Creates a singleton instance of the {@link ReceiptCapture} using the registered
 * plugin.
 */
const instance = new ReceiptCapture(plugin);
export { instance };
//# sourceMappingURL=index.js.map